export const SUBJECT_ABBREVIATIONS = {
    'Mathematics': 'Math',
    'Maths': 'Math',
    'Science': 'Sci',
    'English': 'Eng',
    'Social Studies': 'SS',
    'Social Science': 'SS',
    'Qur\'an': 'Qur',
    'Information Technology': 'IT',
    'Malayalam': 'Mal',
    'Hindi': 'Hin',
    'Arabic': 'Arb',
    'Moral Science': 'MS',
    'History': 'Hist',
    'Geography': 'Geo',
    'Economics': 'Eco',
    'Accounting': 'Acc',
    'Business Studies': 'BS',
    'Computer Science': 'CS',
    'Information Technology': 'IT',
    'General Knowledge': 'GK',
    'Environmental Studies': 'EVS',
}

export const getAbbreviatedSubjectname = (subjectName) => {
    if (!subjectName) return '';

    ///first create a map of common subject names and their abbreviations

    //check if the subject name is in the map
    if (SUBJECT_ABBREVIATIONS[subjectName]) {
        return SUBJECT_ABBREVIATIONS[subjectName];
    }

    //if not, check if the current subject name is more than 4 characters
    if (subjectName.length > 4) {
        return subjectName.slice(0, 4);
    }

    //if not, return the first letter of each word
    return subjectName.split(' ').filter(word => word.length > 0).map(word => word[0]).join('');
}